<h1 matDialogTitle>
    {{ context.data.name }} {{ 'transaction_chart_modal_chart' | translate }}
</h1>

<mat-dialog-content>
    <div class="layout-row layout-wrap">
        <div tabindex="0"
             class="card-container flex-gt-md-33 flex-gt-sm-100 flex-sm-100 flex-xs-100">
            <mat-card class="counter-card mat-card-grey">
                <div class="icon layout-row layout-align-v-center layout-align-h-center">
                    <mat-icon class="text-orange">work</mat-icon>
                </div>
                <div class="info flex">
                    <h3 class="counter text-orange layout-row layout-align-v-end layout-align-h-center">
                        <mat-icon class="time-icon">access_time</mat-icon>
                        {{averageTime?.businessExceptions}}
                    </h3>
                    <p translate
                       class="text-muted text-nowrap text-uppercase">
                        queues_transaction_chart_business_exceptions
                    </p>
                </div>
            </mat-card>
        </div>
        <div tabindex="0"
             class="card-container flex-gt-md-33 flex-gt-sm-100 flex-sm-100 flex-xs-100">
            <mat-card class="counter-card mat-card-grey">
                <div class="icon layout-row layout-align-v-center layout-align-h-center">
                    <mat-icon class="text-red">desktop_windows</mat-icon>
                </div>
                <div class="info flex">
                    <h3 class="counter text-red layout-row layout-align-v-end layout-align-h-center">
                        <mat-icon class="time-icon">access_time</mat-icon>
                        {{averageTime?.applicationExceptions}}
                    </h3>
                    <p translate
                       class="text-muted text-nowrap text-uppercase">
                        queues_transaction_chart_application_exceptions
                    </p>
                </div>
            </mat-card>
        </div>
        <div tabindex="0"
             class="card-container flex-gt-md-33 flex-gt-sm-100 flex-sm-100 flex-xs-100">
            <mat-card class="counter-card mat-card-grey">
                <div class="icon layout-row layout-align-v-center layout-align-h-center">
                    <mat-icon class="text-green">done</mat-icon>
                </div>
                <div class="info flex">
                    <h3 class="counter text-green layout-row layout-align-v-end layout-align-h-center">
                        <mat-icon class="time-icon">access_time</mat-icon>
                        {{averageTime?.succesfulTransactions}}
                    </h3>
                    <p translate
                       class="text-muted text-nowrap text-uppercase">
                        queues_transaction_chart_succesful_transactions
                    </p>
                </div>
            </mat-card>
        </div>
    </div>
    <div class="layout-row layout-wrap">
        <div class="card-container flex-100">
            <mat-card class="chart-card line-chart-card-with-controls">
                <mat-card-header>
                    <mat-card-title>
                        <div class="chart-name-align"
                             tabindex="0">
                            {{ 'page_transactions' | translate }}
                            {{ intervalLabel }}
                        </div>

                        <button (click)="onRefreshClick()"
                                [matTooltip]="'chart_refresh' | translate"
                                mat-icon-button
                                type="button">
                            <mat-icon>refresh</mat-icon>
                        </button>
                        <button [matMenuTriggerFor]="transactionChartMenu"
                                [matTooltip]="'chart_time_period' | translate"
                                mat-icon-button
                                type="button">
                            <mat-icon svgIcon="uipath:More"></mat-icon>
                        </button>
                        <mat-menu #transactionChartMenu="matMenu"
                                  [overlapTrigger]="false">
                            <button *ngFor="let interval of defaultTransactionIntervals"
                                    [class.active]="transactionInterval == interval.value"
                                    (click)="onIntervalChange(interval.value)"
                                    mat-menu-item
                                    type="button">
                                {{ interval.translationKey | translate }}
                            </button>
                        </mat-menu>
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content class="chart-content">
                    <ng-container *uiContentLoading="chart.loading$ | async">
                        <ui-line-chart *ngIf="chart.hasData; else noData"
                                       [legend]="chart.legend"
                                       [colors]="chart.colors"
                                       [data]="chart.data"
                                       [smooth]="true"
                                       [fillAreasBelowLines]="true"
                                       [xAxisLabels]="chart.labels"
                                       [tooltipTrigger]="ChartTooltipTrigger.Axis"
                                       [showXAxisTickLines]="true">
                        </ui-line-chart>
                        <ng-template #noData>
                            <div *ngIf="!chart.hasData &&
                                    !(chart.loading$ | async)"
                                 class="no-chart-message-container"
                                 role="alert">
                                <div translate
                                     class="no-chart-message">
                                    no_data_general
                                </div>
                            </div>
                        </ng-template>
                    </ng-container>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-dialog-close
            mat-button
            type="button">
        {{ 'modal_action_close' | translate }}
    </button>
</mat-dialog-actions>
